import axios from 'axios';

const apiUrl = process.env.CA_IF_API_URL || '[Env var not set: CA_IF_API_URL]';

export const get = async (resource, qs, responseType) => {

  let axiosConstuct = {
    method: 'get',
    url: apiUrl + resource,
    params: qs,
    withCredentials: true
  };

  if (typeof responseType !== 'undefined') {
    axiosConstuct['responseType'] = responseType;
  }

  try {
    const req = await axios(axiosConstuct);

    return req;
  }
  catch ( error ) {
    throw error;
  }
}

